function stackDelete(e){var t=this.__data__,s=t.delete(e);return this.size=t.size,s}module.exports=stackDelete;